<template>
  <div class="auth-select">
    <div
      class="single-select"
      :class="{ expand: item.checked && hasChildren(item) }"
      v-for="(item, index) in ProAuthList"
      :key="'single-select-' + index"
    >
      <Checkbox v-model="item.checked" @on-change="changeSelect($event, index)">{{item.name}}</Checkbox>
      <div class="auth-children" v-if="item.checked && hasChildren(item)">
        <RadioGroup v-model="item.childId" @on-change="send">
          <Radio
            v-for="child in item.childOptions"
            :key="getChildId(child)"
            :label="getChildId(child)"
          >{{ getChildName(child) }}</Radio>
        </RadioGroup>
      </div>
      <div class="auth-upload" :class="{disable: !item.checked}">
        <upload :ref="'select-upload-' + index" :config="uploadBannerConfig" :fileList="item.fileList" @upload-ok="bannerOK($event, index)" v-if="item.isNeedFile && item.checked" />
        <div class="auth-upload-modal"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import upload from "@components/upLoad2/upLoad2";

export default {
  name: "auth-select",
  model: {
    prop: "Modal",
    event: "sendModal",
  },
  props: {
    Modal: {
      type: Array,
      default: function () {
        return [];
      },
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  components: {
    upload,
  },
  data() {
    return {
      ProAuthList: [],
      Authentication: [],
      select: [],
      single: "",

      config: {
        uploadTxt: "证书",
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind: " ",
        limitNum: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
    }),
    uploadBannerConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    option() {
      return { compId: this.company.id, pageSize: 1000 };
    },
  },
  created() {
    this.init();
  },
  watch: {
    Modal(val, oldVal) {
      const valStr = JSON.stringify(val);
      const oldValStr = JSON.stringify(oldVal);
      if (valStr !== oldValStr) {
        this.init();
      }
    },
  },
  methods: {
    ...mapActions({
      getProAuth: "companyInfoModule/getProAuth", // 获取产品标签
      getProQualities: "companyInfoModule/getProQualities", // 获取质量体系认证标签
      getProAuthWithChildren: "companyInfoModule/getProAuthWithChildren", // 获取产品认证（包含下拉项）
    }),
    getChildId(child) {
      return child && (child.id || child.Id) || "";
    },
    getChildName(child) {
      return child && (child.name || child.Name) || "";
    },
    getSelectedList(item) {
      if (!item) return [];
      const list = item.list || item.List;
      return Array.isArray(list) ? list : [];
    },
    hasChildren(item) {
      return !!(item && item.childOptions && item.childOptions.length);
    },
    async init() {
      let reqData = [];
      if (this.type == 1) {
        reqData = await this.getProAuthWithChildren();
      }
      if (this.type == 2) {
        reqData = await this.getProQualities();
      }
      if (reqData.length) {
        reqData.map((c) => {
          c.checked = false;
          c.FilePath = "";
          c.fileList = [];
          c.childId = "";
          c.childOptions = this.getSelectedList(c);
        });
      }
      if (this.Modal && this.Modal[0]) {
        this.Modal.forEach((c) => {
          const selectedChild = this.getSelectedList(c)[0];
          const selectedChildId = this.getChildId(selectedChild);
          reqData.map((v) => {
            if (c.Name === v.name && (c.FilePath || selectedChildId)) {
              v.checked = true;
              v.FilePath = c.FilePath || "";
              v.fileList = c.FilePath && c.FilePath !== "other" ? [c.FilePath] : [];
              if (selectedChildId && this.hasChildren(v)) {
                const matched = v.childOptions.find(
                  (child) => this.getChildId(child) === selectedChildId
                );
                v.childId = matched ? this.getChildId(matched) : "";
              }
            }
          });
        });
      }
      this.ProAuthList = reqData;

      this.send();
    },
    send() {
      let arr = []; // modal 数据
      let errorTxt = ""; // 错误提示
      let arrLen = 0;
      this.ProAuthList.forEach((c) => {
        const selectedChild = this.hasChildren(c)
          ? c.childOptions.find((child) => this.getChildId(child) === c.childId)
          : null;
        if (c.checked) {
          arrLen += 1;
        } else {
          c.FilePath = "";
          c.childId = "";
        }
        if (c.checked && this.hasChildren(c) && !c.childId) {
          errorTxt = errorTxt || `请选择${c.name}的下拉项`;
        }
        if (c.checked && c.isNeedFile && !c.FilePath) {
          errorTxt = errorTxt || `请上传${c.name}的认证文件`;
        }
        const list = [];
        if (c.checked && selectedChild) {
          list.push({
            Id: this.getChildId(selectedChild),
            Name: this.getChildName(selectedChild),
          });
        }
        arr.push({
          Id: c.id,
          Name: c.name,
          FilePath: c.FilePath,
          list,
        });
      });
      if (arrLen === 0 && this.type == 1 && this.ProAuthList.length > 0) {
        errorTxt = "认证选项不能为空";
      }

      this.$emit("sendModal", arr);
      this.$emit("auth", errorTxt);
    },
    bannerOK(list, index) {
      this.uploadBanner = list;
      this.ProAuthList[index].FilePath = list[0] || "";

      this.send();
    },
    changeSelect(e, index) {
      const item = this.ProAuthList[index];
      if (item.name == "其他") {
        item.FilePath = "other";
      }
      if (!e) {
        item.childId = "";
      }
      this.send();
    },
  },
};
</script>

<style scoped lang="scss">
.auth-select {
  display: flex;
  flex-wrap: wrap;
  width: 512px;
  .single-select {
    margin-right: 10px;
    &.expand {
      flex: 1 1 100%;
    }
  }
  .auth-children {
    padding: 4px 0 8px;
    /deep/ .ivu-radio-wrapper {
      margin-right: 16px;
      margin-bottom: 6px;
      white-space: normal;
    }
  }
  .auth-upload {
    width: 100px;
    position: relative;
    &.disable {
      .auth-upload-modal {
        display: block;
      }
    }
    &-modal {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0.2;
      z-index: 2;
    }
  }
}
</style>

